import Awards from '@/components/awards/awards';
import Header from '@/components/header/header';
import Marquee from '@/components/marquee/marquee';

export default class Components {
  constructor() {
    this.header = document.querySelector('.s-header');
    this.awards = document.querySelector('.s-awards');
    this.marquee = document.querySelector('.s-marquee');
  }

  destroy = () => {
    if (this.header) {
      this.header.destroy();
    }
    if (this.awards) {
      this.awards.destroy();
    }
    if (this.marquee) {
      this.marquee.destroy();
    }
  }

  init = () => {
    if (this.header) {
      this.header = new Header();
      this.header.init();
    }
    if (this.awards) {
      this.awards = new Awards();
      this.awards.init();
    }
    if (this.marquee) {
      this.marquee = new Marquee();
      this.marquee.init();
    }
  }
}
